import { Routes, Route } from 'react-router-dom';
import ProfileView from './pages/ProfileView';

function ProfileViewRoutes() {
  return (
    <Routes>
       <Route index element={<ProfileView />} /> {/* This means /profile */}
    </Routes>
  );
}


export default ProfileViewRoutes;
